import appStyles from "../../../App.module.css";
import portugueseConstant from "../../config/portuguese-Constant";

type PPShowApiErrorProps = {
  msg?: string;
};

const PPShowApiError = ({ msg }: PPShowApiErrorProps) => {
  return (
    <div className={appStyles.formRow}>
      <div className={appStyles.battlefaceServerError}>{msg || portugueseConstant.defaultAPIError}</div>
    </div>
  );
};

export default PPShowApiError;
